// extracted by mini-css-extract-plugin
var _1 = "military--reauthorize-module__email--input--L2FwcC";
var _2 = "military--reauthorize-module__email--label--L2FwcC";
var _3 = "military--reauthorize-module__error--box--L2FwcC";
var _4 = "military--reauthorize-module__error--icon--L2FwcC";
var _5 = "military--reauthorize-module__error--message--L2FwcC";
var _6 = "military--reauthorize-module__error--text-container--L2FwcC";
var _7 = "military--reauthorize-module__form--login--L2FwcC";
var _8 = "military--reauthorize-module__govx--footer-note--L2FwcC";
var _9 = "military--reauthorize-module__govx--icon-container--L2FwcC";
var _a = "military--reauthorize-module__govx--subtitle--L2FwcC";
var _b = "military--reauthorize-module__govx--title--L2FwcC";
var _c = "military--reauthorize-module__govx--verify-btn--L2FwcC";
var _d = "military--reauthorize-module__input--instruction--L2FwcC";
var _e = "military--reauthorize-module__input--prefix-icon--L2FwcC";
var _f = "military--reauthorize-module__login--body--L2FwcC";
var _10 = "military--reauthorize-module__logo--web--L2FwcC";
var _11 = "military--reauthorize-module__signup--container--L2FwcC";
var _12 = "military--reauthorize-module__signup--text--L2FwcC";
var _13 = "military--reauthorize-module__success--box--L2FwcC";
var _14 = "military--reauthorize-module__success--icon--L2FwcC";
var _15 = "military--reauthorize-module__success--message--L2FwcC";
export { _1 as "emailInput", _2 as "emailLabel", _3 as "errorBox", _4 as "errorIcon", _5 as "errorMessage", _6 as "errorTextContainer", _7 as "formLogin", _8 as "govxFooterNote", _9 as "govxIconContainer", _a as "govxSubtitle", _b as "govxTitle", _c as "govxVerifyBtn", _d as "inputInstruction", _e as "inputPrefixIcon", _f as "loginBody", _10 as "logoWeb", _11 as "signupContainer", _12 as "signupText", _13 as "successBox", _14 as "successIcon", _15 as "successMessage" }
